import { css } from '@backyard-ui/styles';

const baseStyles = css({
  display: 'block',
  variants: {
    axis: {
      horizontal: {
        width: '$$size',
        minWidth: '$$size',
      },
      vertical: {
        height: '$$size',
        minHeight: '$$size',
      },
    },
  },
  defaultVariants: {
    axis: 'horizontal',
  },
});

export default baseStyles;
